import BaseService from './baseService';

export default {
  getFornecedor(NumCgcFornecedor) {
    return BaseService.get("fornecedor/consultarfornecedor?NumCgcFornecedor=" + NumCgcFornecedor);
  },

  getFornecedorSIMPAS(NumCgcFornecedor, RetornaErroHabilitado = null) {
    let parametroRetornaErro = RetornaErroHabilitado ? `&RetornaErroHabilitado=${RetornaErroHabilitado}` : "";
    return BaseService.get("fornecedor/consultarfornecedorsimpas?NumCgcFornecedor=" + NumCgcFornecedor + parametroRetornaErro);
  },

  getSolicitarAlteracao(NumCgcFornecedor) {
    return BaseService.get("fornecedor/solicitaralteracao" +
     (NumCgcFornecedor ? `?NumCgcFornecedor=${NumCgcFornecedor}`:""));
  },

  getSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/ConsultarSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  fornecedorReabrirSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/FornecedorReabrirSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  fornecedorCancelarSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/FornecedorCancelarSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  listarPCEsFornecedor() {
    return BaseService.get("fornecedor/listarPCEsFornecedor");
  },

  visualizarSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/visualizarSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  getResumoSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/ResumoSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  getAlteracoesSolicitacao(model) {
    return BaseService.post("fornecedor/RetornaAlteracaoSolicitacao", model);
  },
  atualizarSituacaoSolicitacao(model) {
    return BaseService.post(
      "fornecedor/atualizarsituacaosolicitacao", model);
  },
  enviarArquivoSEI(model) {
    return BaseService.post("fornecedor/EnviarArquivoSEI", model);
  },

  getSolicitacaoIncluiSimpas(idFornecSolicitacao) {
    return BaseService.get("fornecedor/ConsultarSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao +"&incluirSimpas=true");
  },

  getModelFornecedor() {
    return BaseService.get("fornecedor/modelfornecedor");
  },

  getListaFornecedorHabilitacaoJuridica() {
    return BaseService.get("fornecedor/consultarlistahabilitacaojuridica");
  },

  getSolicitacaoFornecedor(model) {
    return BaseService.post("fornecedor/listarsolicitacaofornecedor", model);
  },

  getFornecedorNome(NumCgcFornecedor) {
    return BaseService.get("duplaconferencia/getFornecedorNome?NumCgcFornecedor=" + NumCgcFornecedor);
  },
  
  cadastrarDuplaConferencia(model){
    return BaseService.post("duplaconferencia/cadastrarDuplaConferencia", model);
  },

  validaDuplaConferencia(model){
    return BaseService.post("duplaconferencia/validaDuplaConferencia", model.fornecedorSolicitacao);
  },

  getDuplaConferencia(){
    return BaseService.get("duplaconferencia/listarDuplaConferencia");
  },

  getListaCadastro(model){
    return BaseService.post("fornecedor/SolicitacaoComprasnetSimpas", model);
  },

  exportarExcel(model, tipo) {
    return BaseService.exportarExcel(model, tipo);
  },

  atribuirAnalistaFornecedor(model,usuarioAnalistaId) {
    let _usuarioAnalistaId = usuarioAnalistaId ? usuarioAnalistaId : "";
    return BaseService.post("fornecedor/atribuiranalistafornecedor/"+_usuarioAnalistaId, model);
  },
  
  atribuirAnalistaFornecedorLista(model,usuarioAnalistaId) {
    let _usuarioAnalistaId = usuarioAnalistaId ? usuarioAnalistaId : "";
    return BaseService.post("fornecedor/atribuiranalistafornecedorLista/"+_usuarioAnalistaId, model);
  },

  listarSolicitacoes(NumCgcFornecedor) {
    return BaseService.get("fornecedor/ListarSolicitacoes?NumCgcFornecedor=" + NumCgcFornecedor);
  },

  listarHistoricoSolicitacoes(situacaoSolicitacao) {
    return BaseService.get("fornecedor/listarhistoricosolicitacao?situacaoSolicitacao=" + situacaoSolicitacao);
  },

  cadastrarRepresentanteLegal(model){
    return BaseService.post("Fornecedor/cadastrarrepresentantelegal", model);
  } ,

  getRepresentanteLegal(idRepresentanteLegal) {
    return BaseService.get("fornecedor/consultarrepresentante?IdRepresentanteSolicitacao=" + idRepresentanteLegal);
  },

  getRepresentanteLegalUnico(idRepresentanteLegal) {
    return BaseService.get("fornecedor/consultarrepresentanteunico?IdRepresentanteSolicitacao=" + idRepresentanteLegal);
  },
  

  getRepresentanteLegalFornecedor(numCgcFornecedor){
    return BaseService.get("fornecedor/consultaRepresentanteFornecedor?NumCgcFornecedor="+numCgcFornecedor);
  },

  cadastrarfornecedor(model) {  
    model.fornecedorSolicitacao.numCgcFornecedor = model.fornecedorSolicitacao.numCgcFornecedor.replace(/[\W_]+/g, '');

    if (model.fornecedorSolicitacao.regularidadeFiscTrab) {
      model.fornecedorSolicitacao.regularidadeFiscTrab.forEach((item, chave) => {
        delete model.fornecedorSolicitacao.regularidadeFiscTrab[chave].$id;
        delete model.fornecedorSolicitacao.regularidadeFiscTrab[chave].fornecedorDispensa;
      })
    }

    if (model.fornecedorSolicitacao.fornecedoresHabilitacaoJuridica) {
      model.fornecedorSolicitacao.fornecedoresHabilitacaoJuridica = [];
    }

    if (model.listaQualificacaoTecnica) {
      model.listaQualificacaoTecnica.forEach((item) => {
        delete item.$id;
      })
    }

    if (model.fornecedorSolicitacao.qualificacaoTecnica) {
      model.fornecedorSolicitacao.qualificacaoTecnica.forEach((item) => {
        delete item.$id;
      })
    }

    if (model.listaDocumentosSolicitacao) {
      model.listaDocumentosSolicitacao.forEach((item) => {
        delete item.documentosSolicitacao.$id;
      })
    }

    if (model.fornecedorSolicitacao.uploadDeclaracao) {
      model.fornecedorSolicitacao.uploadDeclaracao.forEach((item) => {
        delete item.$id;
      })
    }

    if (model.fornecedorSolicitacao.documentosSolicitacao) {
      model.fornecedorSolicitacao.documentosSolicitacao.forEach((item) => {
        delete item.$id;
      })
    }
    return BaseService.post("fornecedor/cadastrarfornecedor", model)
  },

  confirmarDadosFornecedor(idFornecSolicitacao) {
    return BaseService.post("fornecedor/confirmarDadosFornecedor?idFornecSolicitacao=" + idFornecSolicitacao);
  },

  habilitarRejeitarSolicitacao(model) {

    return BaseService.post("fornecedor/habilitarRejeitarSolicitacao", model)
  },

  cadastrarEditarHabJuridica(model, acao) {
    model.habilitacaoJuridica.numCgcFornecedor = model.habilitacaoJuridica.numCgcFornecedor.replace(/[\W_]+/g, '')
    model.habilitacaoJuridica.cpfCnpj = model.habilitacaoJuridica.cpfCnpj.replace(/[^\d]+/g, '')

    if (acao === "incluir"){
      return BaseService.post("fornecedor/cadastrarhabilitacaojuridica", model)
    } else {
      return BaseService.post("fornecedor/editarhabilitacaojuridica", model)
    }
  },

  aprovarRejeitarHabilitacao(itemLista) {
    return BaseService.post("fornecedor/aprovarRejeitarHabilitacao", itemLista)
  },


  aprovarRejeitarArquivoUpload(model) {
    return BaseService.post("fornecedor/aprovarRejeitarArquivoUpload", model)
  },

  cadastroInicial(model) {
    return BaseService.post("fornecedor/CadastroInicial", model);
  },
  solicitarNovoCadastro(numCgcFornecedor) {
    return BaseService.get("fornecedor/solicitarnovocadastro?numCgcFornecedor=" + numCgcFornecedor);
  },
  solicitarAlteracaoHabilitador(numCgcFornecedor) {
    return BaseService.get("fornecedor/solicitarAlteracao?numCgcFornecedor=" + numCgcFornecedor + "&habilitador=1");
  },
  solicitarAlteracao(numCgcFornecedor) {
    return BaseService.get("fornecedor/solicitarAlteracao?numCgcFornecedor=" + numCgcFornecedor);
  },

  carregarDashboard(tipoDashboard) {
    return BaseService.get("fornecedor/carregardashboard?tipoDashboard=" + tipoDashboard);
  },

  consultarTipoSolicitacaoDashboard(ano) {
    return BaseService.get("fornecedor/carregardashboard?tipoDashboard=2&ano=" + ano);
  },

  consultarQuantitativoSolicitacoesDashboard(dataIni, dataFim) {
    return BaseService.get("fornecedor/carregardashboard?tipoDashboard=5&dataIni=" + dataIni + "&dataFim=" + dataFim);
  },

  getDiasUltimaSolicitacao(idForneceSolicitacao) {
    return BaseService.get("fornecedor/obterDiasUltimaSolicitacao?idSolicitacao=" + idForneceSolicitacao);
  },

  put(model) {
    return BaseService.put("values", model);
  },

  baixarArquivo(arquivo, numCgcFornecedor = null) {
    BaseService.baixarArquivo(arquivo, numCgcFornecedor);
  },

  deleteFornecedorHabilitacaoJuridica(idFornecHabilitacaoJur) {
    return BaseService.delete("fornecedor/excluirHabilitacaoJuridica/" + idFornecHabilitacaoJur);
  },
  deleteArquivo(arquivo) {
    return BaseService.delete("arquivo/excluir/" + arquivo);
  },
  enviarFornecedor(model) {
    if (model.listaDocumentosSolicitacao) {

      model.listaDocumentosSolicitacao.forEach((item) => {

        delete item.documentosSolicitacao.$id;
      })
    }

    if (model.fornecedorSolicitacao.uploadDeclaracao) {

      model.fornecedorSolicitacao.uploadDeclaracao.forEach((item) => {

        delete item.$id;
      })
    }

    if (model.fornecedorSolicitacao.documentosSolicitacao) {

      model.fornecedorSolicitacao.documentosSolicitacao.forEach((item) => {

        delete item.$id;
      })
    }
    model.fornecedorSolicitacao.numCgcFornecedor = model.fornecedorSolicitacao.numCgcFornecedor.replace(/[\W_]+/g, '')
    return BaseService.post("fornecedor/enviarfornecedor", model)
  },
  upload(arquivo) {
    arquivo.UniqueName = arquivo.UniqueName.replace(/[\W_]+/g, '')
    return BaseService.post("arquivo/upload", arquivo)
  },
  confirmaEdicaoImpressaoTermo(idFornecSolicitacao){
    return BaseService.put(`fornecedor/confirmaEdicaoImpressaoTermo/${idFornecSolicitacao}`);
  },
  getTipoCertificadoCasdastradoSimpas(numCgcFornecedor){
    return BaseService.get(`fornecedor/certificadoCadastradoSimpas/${numCgcFornecedor}`);
  },
  getQtdSolicitcaoesFornec(numCgcFornecedor){
    return BaseService.get(`fornecedor/getQtdSolicitcaoesFornec/${numCgcFornecedor}`);
  },
  ObtemRegistroCadastral(numCgcFornecedor){
    return BaseService.get(`fornecedor/ObtemRegistroCadastral/${numCgcFornecedor}`);
  },
  GetDocRelatorioRegistroCadastral(numCgcFornecedor){
    return BaseService.get(`fornecedor/getDocRelatorioRegistroCadastral/${numCgcFornecedor}`);
  },
  ObtemSituacaoFornecedorSimeb(numCgcFornecedor) {
    return BaseService.get(`fornecedor/ConsultaFornecedorSimeb/${numCgcFornecedor}`);
  },
  getRegularidadeFiscalTipoDoc(numCgcFornecedor, tipoDoc) {
    return BaseService.get("fornecedor/GetRegularidadeFiscalTipoDoc?numCgcFornecedor=" + numCgcFornecedor + "&tipoDoc=" + tipoDoc);
  }
};
